import { FC, SVGProps } from "react";

// ----------------------------------------------------------------------------------

export type ILinkedinProps = SVGProps<SVGSVGElement> & {
  variant: "white" | "black" | "normal" | "yellow";
};

const Linkedin: FC<ILinkedinProps> = (props) => {
  const { variant, className, ...other } = props;

  return (
    <>
      {variant === "white" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6770)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.83333 30H27.1667C29.0076 30 30.5 28.5076 30.5 26.6667V3.33333C30.5 1.49238 29.0076 0 27.1667 0H3.83333C1.99238 0 0.5 1.49238 0.5 3.33333V26.6667C0.5 28.5076 1.99238 30 3.83333 30Z"
              fill="#FFFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.3327 25.8332H21.8809V18.2507C21.8809 16.1718 21.0909 15.0101 19.4455 15.0101C17.6554 15.0101 16.7202 16.2191 16.7202 18.2507V25.8332H12.4299V11.3887H16.7202V13.3344C16.7202 13.3344 18.0102 10.9474 21.0754 10.9474C24.1392 10.9474 26.3327 12.8184 26.3327 16.6878V25.8332ZM7.31158 9.49734C5.85021 9.49734 4.66602 8.30386 4.66602 6.83192C4.66602 5.35999 5.85021 4.1665 7.31158 4.1665C8.77295 4.1665 9.95643 5.35999 9.95643 6.83192C9.95643 8.30386 8.77295 9.49734 7.31158 9.49734ZM5.09625 25.8332H9.56993V11.3887H5.09625V25.8332Z"
              fill="#054ADA"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6770">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "black" && (
        <svg
          width="25"
          height="25"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6770)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.83333 30H27.1667C29.0076 30 30.5 28.5076 30.5 26.6667V3.33333C30.5 1.49238 29.0076 0 27.1667 0H3.83333C1.99238 0 0.5 1.49238 0.5 3.33333V26.6667C0.5 28.5076 1.99238 30 3.83333 30Z"
              fill="#252C37"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.3327 25.8332H21.8809V18.2507C21.8809 16.1718 21.0909 15.0101 19.4455 15.0101C17.6554 15.0101 16.7202 16.2191 16.7202 18.2507V25.8332H12.4299V11.3887H16.7202V13.3344C16.7202 13.3344 18.0102 10.9474 21.0754 10.9474C24.1392 10.9474 26.3327 12.8184 26.3327 16.6878V25.8332ZM7.31158 9.49734C5.85021 9.49734 4.66602 8.30386 4.66602 6.83192C4.66602 5.35999 5.85021 4.1665 7.31158 4.1665C8.77295 4.1665 9.95643 5.35999 9.95643 6.83192C9.95643 8.30386 8.77295 9.49734 7.31158 9.49734ZM5.09625 25.8332H9.56993V11.3887H5.09625V25.8332Z"
              fill="#EFFBFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6770">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "normal" && (
        <svg
          width="31"
          height="30"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6770)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.83333 30H27.1667C29.0076 30 30.5 28.5076 30.5 26.6667V3.33333C30.5 1.49238 29.0076 0 27.1667 0H3.83333C1.99238 0 0.5 1.49238 0.5 3.33333V26.6667C0.5 28.5076 1.99238 30 3.83333 30Z"
              fill="#5E5E5E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.3327 25.8332H21.8809V18.2507C21.8809 16.1718 21.0909 15.0101 19.4455 15.0101C17.6554 15.0101 16.7202 16.2191 16.7202 18.2507V25.8332H12.4299V11.3887H16.7202V13.3344C16.7202 13.3344 18.0102 10.9474 21.0754 10.9474C24.1392 10.9474 26.3327 12.8184 26.3327 16.6878V25.8332ZM7.31158 9.49734C5.85021 9.49734 4.66602 8.30386 4.66602 6.83192C4.66602 5.35999 5.85021 4.1665 7.31158 4.1665C8.77295 4.1665 9.95643 5.35999 9.95643 6.83192C9.95643 8.30386 8.77295 9.49734 7.31158 9.49734ZM5.09625 25.8332H9.56993V11.3887H5.09625V25.8332Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1304_6770">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default Linkedin;
